function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("rect", {
  x: 0.5,
  width: 28,
  height: 28,
  rx: 4,
  fill: "#252CA0"
});

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  clipPath: "url(#clip0_15376_421300)"
}, React.createElement("path", {
  d: "M20.3984 24H8.60156C6.33996 24 4.5 22.16 4.5 19.8984V8.10156C4.5 5.83996 6.33996 4 8.60156 4H20.3984C22.66 4 24.5 5.83996 24.5 8.10156V19.8984C24.5 22.16 22.66 24 20.3984 24Z",
  fill: "white"
}), React.createElement("path", {
  d: "M20.4624 13.1055L19.1648 14.2814L18.0051 11.5867L14.5173 18.4055L12.4765 13.4605L11.0093 16.2244L9.57414 14.7892L8.5891 16.1872H4.49609V19.8982C4.49609 22.1598 6.33605 23.9997 8.59766 23.9997H20.3945C22.6561 23.9997 24.4961 22.1598 24.4961 19.8982V15.7185H21.8377L20.4624 13.1055Z",
  fill: "#0F0B6A"
}), React.createElement("path", {
  d: "M20.3945 3.99976H8.59766C6.33605 3.99976 4.49609 5.83972 4.49609 8.10132V15.0154H7.98121L9.41809 12.9759L10.7173 14.2751L12.6095 10.7108L14.6311 15.6096L18.0965 8.83464L19.593 12.3118L20.7954 11.2221L22.5452 14.5466H24.4961V8.10132C24.4961 5.83972 22.6561 3.99976 20.3945 3.99976Z",
  fill: "#0F0B6A"
}), React.createElement("path", {
  d: "M18.875 4H17.625V24H18.875V4Z",
  fill: "url(#paint0_linear_15376_421300)"
}), React.createElement("path", {
  d: "M18.25 10.875C18.9404 10.875 19.5 10.3154 19.5 9.625C19.5 8.93464 18.9404 8.375 18.25 8.375C17.5596 8.375 17 8.93464 17 9.625C17 10.3154 17.5596 10.875 18.25 10.875Z",
  fill: "#E390E1"
}));

var _ref4 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "paint0_linear_15376_421300",
  x1: 18.9001,
  y1: 4,
  x2: 16.9016,
  y2: 4.07232,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#EA4AC7"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#B960CC"
})), React.createElement("clipPath", {
  id: "clip0_15376_421300"
}, React.createElement("rect", {
  width: 20,
  height: 20,
  fill: "white",
  transform: "translate(4.5 4)"
})));

var SvgPhantichActive = function SvgPhantichActive(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgPhantichActive, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/phantich_active.b9ad55a0.svg";
export { ForwardRef as ReactComponent };